import { deleteCookie, setCookie } from "cookies-next";
import { getAuth, onIdTokenChanged, User } from "firebase/auth";
import { useEffect, useRef } from "react";

export function useUserSession(initialUser: User | null) {
  const isInitialLoad = useRef(true);

  useEffect(() => {
    return onIdTokenChanged(getAuth(), async (user) => {
      // Update session cookie
      if (user) {
        const idToken = await user.getIdToken();
        // Set cookie with proper options for server-side access
        setCookie("__session", idToken, {
          path: "/",
          sameSite: "lax",
          secure: process.env.NODE_ENV === "production",
          maxAge: 60 * 60 * 24 * 7, // 7 days
        });
      } else {
        deleteCookie("__session", { path: "/" });
      }

      //   // Skip reload on initial load
      //   if (isInitialLoad.current) {
      //     isInitialLoad.current = false;
      //     return;
      //   }

      //   // Only reload if the user actually changed
      //   if (initialUser?.uid !== user?.uid) {
      //     // Suppress reload during email link verification flow to avoid canceling critical requests
      //     const inVerifyFlow =
      //       typeof window !== "undefined" &&
      //       window.location.pathname.startsWith("/auth/verify-email");
      //     const suppressReload =
      //       typeof window !== "undefined" &&
      //       window.sessionStorage.getItem("suppressAuthReload") === "1";

      //     if (inVerifyFlow || suppressReload) {
      //       try {
      //         if (suppressReload) {
      //           window.sessionStorage.removeItem("suppressAuthReload");
      //         }
      //       } catch {
      //         // Ignore sessionStorage errors
      //       }
      //       return; // do not reload this page; let the flow proceed
      //     }

      //     window.location.reload();
      //   }
    });
  }, [initialUser?.uid]);

  return initialUser;
}
